package com.iregained.site.components.sections.home.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgba
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

// 1. Handles the zoom effect on the thumbnail image
val TestimonialThumbnailStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("transform", 0.4.s))
    }
    hover {
        Modifier.scale(1.05)
    }
}

// 2. NEW: The continuous ripple animation keyframes
val PlayRippleKeyframes = Keyframes {
    0.percent {
        // Start with a strong white shadow tight to the button
        Modifier.boxShadow(0.px, 0.px, 0.px, 0.px, rgba(255, 255, 255, 0.6f))
    }
    50.percent {
        // Expand the shadow outward by 20px while fading to transparent
        Modifier.boxShadow(0.px, 0.px, 0.px, 20.px, rgba(255, 255, 255, 0f))
    }
    100.percent {
        // Keep transparent to create a pause before the next pulse
        Modifier.boxShadow(0.px, 0.px, 0.px, 0.px, color = rgba(255, 255, 255, 0f))
    }
}

// 3. UPDATED: Apply the infinite animation and fix the hover bug
val TestimonialPlayButtonStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.zIndex(1).backgroundColor(palette.brand.primary) // Keep it permanently Teal to fix the vanish bug
            .animation(
                PlayRippleKeyframes.toAnimation(
                    duration = 1.s, iterationCount = AnimationIterationCount.Infinite // Pulses forever
                )
            ).transition(
                Transition.of("transform", 0.3.s), Transition.of("background-color", 0.3.s)
            )
    }
    hover {
        Modifier.scale(1.15) // Extra pop when hovered
            .backgroundColor(palette.brand.primaryHover) // Slightly darken on hover
    }
}